// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"5dd07e23","707":"381f8b96","729":"00eae2be"}[chunkId] + ".js";
};